/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var StyleUtils = {
  border: function border(css) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var style = {};
    var splt = css.split(' ');

    if (splt.length !== 3) {
      console.warn('Malformed border style passed to border shorthand unpacker');
      return {
        border: css
      };
    }

    style["border".concat(side, "Width")] = parseInt(splt[0].replace('px', ''));
    style["border".concat(side, "Style")] = splt[1];
    style["border".concat(side, "Color")] = splt[2];
    return style;
  },
  borderBottom: function borderBottom(css) {
    return StyleUtils.border(css, 'Bottom');
  },
  borderLeft: function borderLeft(css) {
    return StyleUtils.border(css, 'Left');
  },
  borderRight: function borderRight(css) {
    return StyleUtils.border(css, 'Right');
  },
  borderTop: function borderTop(css) {
    return StyleUtils.border(css, 'Top');
  },
  borderRadius: function borderRadius(css) {
    var style = {};
    var sides = css.split(' ').map(function (s) {
      return parseInt(s.replace('px', ''));
    });

    if (sides.length !== 4) {
      console.warn('Malformed border style passed to borderRadius shorthand unpacker');
      return {
        borderRadius: css
      };
    }

    style['borderTopLeftRadius'] = sides[0];
    style['borderTopRightRadius'] = sides[1];
    style['borderBottomRightRadius'] = sides[2];
    style['borderBottomLeftRadius'] = sides[3];
    return style;
  },
  margin: function margin(css) {
    return StyleUtils.unpackShorthand(css, 'margin');
  },
  padding: function padding(css) {
    return StyleUtils.unpackShorthand(css, 'padding');
  },
  unpackShorthand: function unpackShorthand(css, name) {
    var style = {};
    var sides = css.split(' ').map(function (s) {
      return s === 'auto' ? 'auto' : parseInt(s.replace('px', ''));
    });

    if (sides[0]) {
      style["".concat(name, "Top")] = sides[0];
    }

    if (sides.length === 1) {
      sides = sides.concat(sides[0], sides[0], sides[0]);
    }

    if (sides[1]) {
      style["".concat(name, "Right")] = sides[1];
    }

    if (sides.length === 2) {
      sides = sides.concat(sides[0], sides[1]);
    }

    if (sides[2]) {
      style["".concat(name, "Bottom")] = sides[2];
    }

    if (sides.length === 3) {
      sides.push(sides[1]);
    }

    if (sides[3]) {
      style["".concat(name, "Left")] = sides[3];
    }

    return style;
  }
};
exports.default = StyleUtils;